export const labels = {
  ORGANISATION: 'Organisatie',
  PLAN_STATUS: 'Planstatus',
  PROJECT_TYPE: 'Projecttype',
  LAST_UPDATED: 'Laatst bijgewerkt',
};